import { Map } from 'immutable';
import { Reducer } from 'redux';

import { DonationCreditRuleActions } from 'entities/donationCreditRule/actions';

import { ADD, ADD_MULTIPLE, REMOVE, UPDATE } from './constants';
import DonationCreditRule from './model';

const initialState = Map<string, DonationCreditRule>();

export type DonationCreditRuleState = Map<string, DonationCreditRule>;

const donationCreditRuleReducer: Reducer<DonationCreditRuleState, DonationCreditRuleActions> = (
  state: DonationCreditRuleState = initialState,
  action: DonationCreditRuleActions
) => {
  switch (action.type) {
    case ADD:
      return state.set(action.donationCreditRule.id, action.donationCreditRule);

    case ADD_MULTIPLE:
      return state.merge(action.donationCreditRules);

    case UPDATE:
      return state.set(action.donationCreditRule.id, action.donationCreditRule);

    case REMOVE:
      return state.delete(action.id);

    default:
      return state;
  }
};

export default donationCreditRuleReducer;
